import * as React from 'react';
import { Utils } from '../../../common/views/Utils';
import { OrderTrackingInfo, TrackingStatus } from '../../models/OrderModel';

type OrderTrackingProps = {
    trackings: OrderTrackingInfo[];
}

export default function OrderTrackingView({ trackings }: OrderTrackingProps) {
    const width: number = Math.floor(100 / trackings.length);
    const lastWidth: number = width + (100 - width * trackings.length);
    const cssName = "rs-tracker as-l-container-full-small as-l-container-mobileoverflow";

    const printItem = (item: OrderTrackingInfo, index: number, arr: OrderTrackingInfo[]) => {
        const itemWidth = (index === arr.length - 1 ? lastWidth : width) + "%";

        return <>
            {item.status !== TrackingStatus.inProgress && <li style={{ width: itemWidth }}>
                <span>
                    <span className="rs-status">
                        {Utils.splitCapitalCase(item.name)}
                    </span>
                    <span className="rs-status-a11y">{item.status}</span>
                </span>
            </li>}

            {item.status === TrackingStatus.inProgress && <>
                <li aria-current="step" style={{ width: itemWidth }}>
                    <span>
                        <span className="rs-status rs-status-current">
                            {Utils.splitCapitalCase(item.name)}
                        </span>
                        <span className="rs-status-a11y">{item.status}</span>
                    </span>
                </li>
            </>}
        </>;
    }

    const getCurrentIndex = (trackings: OrderTrackingInfo[]) => {
        for (let i = 0; i < trackings.length; i++) {
            if (trackings[i].status === TrackingStatus.inProgress) {
                return i;
            }
        }

        return trackings.length - 1;
    }

    const getFillWidth = () => {
        const currentIndex = getCurrentIndex(trackings);
        return currentIndex === trackings.length - 1 ? 100 : (width * (currentIndex + 0.5));
    }

    return <div className={cssName} style={{ width: "100%" }}>
        <div className="as-l-container-mobileoverflow-content left">
            <div className="rs-tracker-bar">
                <div className="rs-tracker-fill" style={{ width: getFillWidth() + "%" }}></div>
            </div>
            <ol className="rs-tracker-status" style={{ paddingInlineStart: 0, fontSize: 10 }}>
                {trackings.map(printItem)}
            </ol>
        </div>
    </div>;
}